import PropTypes from 'prop-types';
import React from 'react';
import { InputLabel, MenuItem, Select as MSelect } from '@material-ui/core';
import useStyles from './styles';

const Select = (props) => {
    const classes = useStyles();
    const { items, label } = props;
    const selectProps = { ...props };
    delete selectProps.helperText;

    return (
        <>
            <InputLabel shrink>{label}</InputLabel>
            <MSelect
                classes={classes}
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                }}
                {...selectProps}
            >
                {items &&
                    items.map((item, index) => {
                        if (item) {
                            if (item.Icon) {
                                const Icon = item.Icon;
                                return (
                                    <MenuItem
                                        key={item.value}
                                        value={item.value}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                            }}
                                        >
                                            <Icon size="16" />
                                            {item.label}
                                        </div>
                                    </MenuItem>
                                );
                            } else {
                                return (
                                    <MenuItem
                                        key={index}
                                        value={item.value}
                                    >
                                        {item.label}
                                    </MenuItem>
                                );
                            }
                        } else {
                            return null;
                        }
                    })}
            </MSelect>
        </>
    );
};

export default Select;

Select.propTypes = {
    items: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
};
